import {defaultEnvironment as defaultEnvironment, Environment} from './environment.defaults';
import * as _ from 'lodash';

export const environment: Environment = _.merge<Environment, Environment>(defaultEnvironment, {
  angularProductionMode: true
});
